import React from 'react'

const meetings = [
  {
    title: 'Design system meeting',
    time: '9 - 10 AM',
    participans: [
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/F4.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/F5.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M3.jpg',
    ],
  },
  {
    title: 'Lunch',
    time: '1 - 2 PM',
    participans: [],
  },
  {
    title: 'Design review',
    time: '3 - 4 PM',
    participans: [
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/F5.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M3.jpg',
    ],
  },
]

export const SectionMeetingDemo = () => {
  return (
    <section
      className='mk-comp mk-comp-section relative'
      data-component-type='section'
      style={
        {
          width: 'calc(100% + 0px)',
          alignSelf: 'center',
          margin: '0px',
          padding: '20px 10px 16px',
          '--field-color-label': 'var(--color-on-primary-20)',
          '--field-color-bg': 'var(--color-primary-95)',
          '--field-color-fg': 'var(--color-on-primary-95)',
          '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
          '--field-color-accent': 'var(--color-primary-40)',
          '--field-color-on-accent': 'var(--color-on-primary-40)',
          '--field-color-active': 'var(--color-on-primary-95)',
          '--field-color-on-active': 'var(--color-primary-95)',
          '--field-color-focus': 'var(--color-primary-50)',
          '--field-color-thumb': 'var(--color-primary-90)',
          '--field-color-on-thumb': 'var(--color-on-primary-90)',
          '--field-color-checked': 'var(--color-primary-40)',
          '--field-color-unchecked': 'var(--color-primary-10)',
          '--field-color-border': 'var(--color-neutral-60)',
          '--field-color-outline': 'var(--color-neutral-60)',
          '--focus-border': 'var(--color-primary-50)',
          '--focus-ring': 'var(--color-primary-50)',
          '--border-radius': 'var(--radius-md)',
          '--field-label-font': 'var(--typo-label-large-font)',
          '--field-input-font': 'var(--typo-body-medium-font)',
          '--field-supporting-text-font': 'var(--typo-label-small-font)',
          color: 'rgba(0, 0, 0, 0.98)',
          borderRadius: 'var(--radius-md)',
          '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
          zIndex: 0,
          maxWidth: '100%',
          minHeight: '100%',
          height: 'auto',
          overflow: 'hidden',
          gap: '16px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        } as React.CSSProperties
      }
    >
      <div
        className='absolute inset-0'
        style={{
          overflow: 'hidden',
          borderRadius: 'inherit',
          zIndex: -1,
          borderTop: '0px solid var(--color-primary-70)',
          borderInlineEnd: '0px solid var(--color-primary-70)',
          borderBottom: '0px solid var(--color-primary-70)',
          borderInlineStart: '0px solid var(--color-primary-70)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: -6,
            background: 'var(--color-primary-10)',
          }}
        />
      </div>
      <h2 className='text-2xl text-left w-full font-bold text-[var(--color-on-primary-20)] mb-0'>Meetings</h2>
      {meetings.map((meeting) => (
        <section
          key={meeting.title}
          className='mk-comp mk-comp-section relative'
          data-component-type='section'
          style={
            {
              width: 'calc(100% + 0px)',
              alignSelf: 'center',
              margin: '0px',
              padding: '8px 8px 8px 32px',
              '--field-color-label': 'var(--color-on-primary-20)',
              '--field-color-bg': 'var(--color-primary-95)',
              '--field-color-fg': 'var(--color-on-primary-95)',
              '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
              '--field-color-accent': 'var(--color-primary-40)',
              '--field-color-on-accent': 'var(--color-on-primary-40)',
              '--field-color-active': 'var(--color-on-primary-95)',
              '--field-color-on-active': 'var(--color-primary-95)',
              '--field-color-focus': 'var(--color-primary-50)',
              '--field-color-thumb': 'var(--color-primary-90)',
              '--field-color-on-thumb': 'var(--color-on-primary-90)',
              '--field-color-checked': 'var(--color-primary-40)',
              '--field-color-unchecked': 'var(--color-primary-10)',
              '--field-color-border': 'var(--color-neutral-60)',
              '--field-color-outline': 'var(--color-neutral-60)',
              '--focus-border': 'var(--color-primary-50)',
              '--focus-ring': 'var(--color-primary-50)',
              '--border-radius': 'var(--radius-md)',
              '--field-label-font': 'var(--typo-label-large-font)',
              '--field-input-font': 'var(--typo-body-medium-font)',
              '--field-supporting-text-font': 'var(--typo-label-small-font)',
              color: 'rgba(0, 0, 0, 0.98)',
              borderRadius: 'var(--radius-md)',
              '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
              zIndex: 0,
              maxWidth: '100%',
              minHeight: '100%',
              height: 'auto',
              overflow: 'hidden',
              gap: '10px',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            } as React.CSSProperties
          }
        >
          <style>
            {`.mk-comp-section > .mk-comp {
          height: auto !important;
        }`}
          </style>
          <div
            className='absolute inset-0'
            style={{
              overflow: 'hidden',
              borderRadius: 'inherit',
              zIndex: -1,
              borderInlineStart: '16px solid var(--color-primary-70)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -1,
                backgroundColor: 'rgb(0, 0, 0)',
                opacity: 0,
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -2,
                color: 'currentcolor',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -3,
                objectFit: 'cover',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -4,
                backgroundImage: 'url("undefined")',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundAttachment: 'scroll',
                transition: 'transform 0.1s ease-out',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -5,
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -6,
                background: 'var(--color-primary-20)',
              }}
            ></div>
          </div>

          <div
            className='mk-comp border border-solid rounded-md text-base break-words text-start text-on-primary-20 t94x3a7'
            style={
              {
                '--t94x3a7-0': 'start',
                '--t94x3a7-1': 'solid',
                '--t94x3a7-2': 'var(--color-on-primary-20)',
                '--t94x3a7-3': '1px',
                '--t94x3a7-4': '0px',
                '--t94x3a7-5': '0px',
                '--t94x3a7-6': '0px',
                '--t94x3a7-7': '0px',
                width: 'calc(100% + 0px)',
                alignSelf: 'unset',
                margin: '0px',
                padding: '0px',
                font: 'var(--typo-title-medium-font)',
                letterSpacing: 'var(--typo-title-medium-tracking)',
              } as React.CSSProperties
            }
          >
            <span className='mb-2 last:mb-0' style={{ whiteSpace: 'pre-wrap', textAlign: 'start' }}>
              {meeting.title}
            </span>
          </div>

          <div
            className='mk-comp border border-solid rounded-md text-base break-words text-start text-on-primary-20 t94x3a7'
            style={
              {
                '--t94x3a7-0': 'start',
                '--t94x3a7-1': 'solid',
                '--t94x3a7-2': 'var(--color-on-primary-20)',
                '--t94x3a7-3': '1px',
                '--t94x3a7-4': '0px',
                '--t94x3a7-5': '0px',
                '--t94x3a7-6': '0px',
                '--t94x3a7-7': '0px',
                width: 'calc(100% + 0px)',
                alignSelf: 'unset',
                margin: '0px',
                padding: '0px',
                font: 'var(--typo-body-small-font)',
                letterSpacing: 'var(--typo-body-small-tracking)',
              } as React.CSSProperties
            }
          >
            <span className='mb-3 last:mb-0' style={{ whiteSpace: 'pre-wrap', textAlign: 'start' }}>
              {meeting.time}
            </span>
            <br />
          </div>

          <section
            id='1214d894-3ff6-4748-b9d1-243534aad847'
            data-el='1214d894-3ff6-4748-b9d1-243534aad847'
            className='mk-comp mk-comp-section relative'
            data-component-type='section'
            style={
              {
                width: 'calc(100% + 0px)',
                alignSelf: 'flex-start',
                margin: '0px',
                padding: '0px',
                '--field-color-label': 'var(--color-on-primary-20)',
                '--field-color-bg': 'var(--color-primary-95)',
                '--field-color-fg': 'var(--color-on-primary-95)',
                '--field-color-placeholder': 'color-mix(in oklch, var(--color-on-primary-95) 68%, transparent)',
                '--field-color-accent': 'var(--color-primary-40)',
                '--field-color-on-accent': 'var(--color-on-primary-40)',
                '--field-color-active': 'var(--color-on-primary-95)',
                '--field-color-on-active': 'var(--color-primary-95)',
                '--field-color-focus': 'var(--color-primary-50)',
                '--field-color-thumb': 'var(--color-primary-90)',
                '--field-color-on-thumb': 'var(--color-on-primary-90)',
                '--field-color-checked': 'var(--color-primary-40)',
                '--field-color-unchecked': 'var(--color-primary-10)',
                '--field-color-border': 'var(--color-neutral-60)',
                '--field-color-outline': 'var(--color-neutral-60)',
                '--focus-border': 'var(--color-primary-50)',
                '--focus-ring': 'var(--color-primary-50)',
                '--border-radius': 'var(--radius-md)',
                '--field-label-font': 'var(--typo-label-large-font)',
                '--field-input-font': 'var(--typo-body-medium-font)',
                '--field-supporting-text-font': 'var(--typo-label-small-font)',
                color: 'rgba(0, 0, 0, 0.98)',
                borderRadius: '0px',
                '--tw-ui-text-active': 'rgba(0, 0, 0, 0.98)',
                zIndex: 0,
                maxWidth: '100%',
                minHeight: '100%',
                height: 'auto',
                overflow: 'hidden',
                gap: '4px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              } as React.CSSProperties
            }
          >
            {meeting.participans.map((participant) => (
              <div
                className='mk-comp relative inset-0 overflow-hidden rounded-full'
                key={participant}
                style={{
                  borderWidth: '0px',
                  backgroundColor: 'var(--color-neutral-70)',
                  borderColor: 'var(--color-primary-80)',
                  aspectRatio: '1 / 1',
                  width: 'min(100%, 40px)',
                  alignSelf: 'unset',
                  margin: '0px',
                  padding: '0px',
                }}
              >
                <img src={participant} alt='' className='w-full h-full object-cover rounded-full' />
                <div className='absolute top-2 left-2 right-2 z-10 flex items-center justify-between max-w-full overflow-hidden gap-2'></div>
              </div>
            ))}
          </section>
        </section>
      ))}
    </section>
  )
}
